import { Link } from "react-router-dom";
import { Instagram, Phone, Mail, MapPin, Star, Linkedin } from "lucide-react";
import { SITE } from "@/data/site";
import { useLang } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  const links = [
    { to: "/", l: t.nav.home },
    { to: "/coaching-en-salle", l: t.nav.salle },
    { to: "/coaching-a-domicile", l: t.nav.domicile },
    { to: "/coaching-en-ligne", l: t.nav.ligne },
    { to: "/a-propos", l: t.nav.about },
    { to: "/contact", l: t.nav.contact },
  ];
  return (
    <footer data-testid="footer" className="relative bg-night text-white overflow-hidden">
      <div className="max-w-8xl mx-auto px-5 sm:px-6 lg:px-12 pt-14 lg:pt-16 pb-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-6">
            <h3 className="text-sm uppercase tracking-[0.2em] text-white/50 mb-5">{t.footer.navigation}</h3>
            <ul className="space-y-3">
              {links.map((i) => (
                <li key={i.to}>
                  <Link to={i.to} className="text-white/80 hover:text-accentbrand transition-colors">{i.l}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-6">
            <h3 className="text-sm uppercase tracking-[0.2em] text-white/50 mb-5">{t.footer.contact}</h3>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-center gap-3"><MapPin size={16} className="text-accentbrand" /> {SITE.city}, France</li>
              <li>
                <a href={SITE.whatsappLink} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 hover:text-accentbrand transition-colors">
                  <Phone size={16} className="text-accentbrand" /> {SITE.whatsappNumber}
                </a>
              </li>
              <li>
                <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="flex items-center gap-3 hover:text-accentbrand transition-colors">
                  <Mail size={16} className="text-accentbrand" /> {SITE.email}
                </a>
              </li>
              <li>
                <a href={SITE.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="flex items-center gap-3 hover:text-accentbrand transition-colors">
                  <Instagram size={16} className="text-accentbrand" /> @coach_gi06
                </a>
              </li>
              <li>
                <a href={SITE.linkedin} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="flex items-center gap-3 hover:text-accentbrand transition-colors">
                  <Linkedin size={16} className="text-accentbrand" /> {t.common.linkedin}
                </a>
              </li>
              <li>
                <a href={SITE.googleReviewsUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-google" className="flex items-center gap-3 hover:text-accentbrand transition-colors">
                  <Star size={16} className="text-accentbrand" /> {t.footer.googleReviews}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-sm text-white/50">
          <p>© {new Date().getFullYear()} Gihed Coaching — {t.footer.rights}</p>
          <div className="flex gap-6">
            <Link to="/mentions-legales" data-testid="footer-legal" className="hover:text-white transition-colors">{t.footer.legal}</Link>
            <Link to="/confidentialite" data-testid="footer-privacy" className="hover:text-white transition-colors">{t.footer.privacy}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
